<template>
  <div class="samplePage-box" :class="{ dark: theme == 'dark' }">
    <el-pagination
      v-bind="$attrs"
      :current-page="currentPage"
      :layout="layout"
      :page-size="pageSize"
      :total="total"
      @current-change="handleCurrentChange"
    >
      <div class="page-info-tip">
        <slot name="customPage">
          {{ currentPage }} <em class="page-info-tip-line">/</em> {{ total }}
        </slot>
      </div>
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "SamplePagination",
  components: {},
  // 接收父组件传过来的值
  props: {
    total: {
      required: true,
      type: Number,
    },

    currentPage: {
      type: Number,
      default: 1, // 默认第一页
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    layout: {
      type: String,
      default: "prev, slot, next",
    },
    theme: {
      type: String,
      default: "light",
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleCurrentChange(val) {
      this.$emit("current-change", { pageIndex: val, pageSize: this.pageSize });
    },
  },
};
</script>

<style lang="scss">
.samplePage-box {
  .page-info-tip {
    display: inline-block;
    padding: 0 8px;
    font-size: 18px;
    color: #fff;
    font-style: normal;
    font-weight: normal;
    .page-info-tip-line {
      padding: 0 16px;
      font-size: 18px;
      font-style: normal;
      font-weight: normal;
      line-height: 22px;
    }
  }
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    height: 24px;
    line-height: 24px;
    font-size: 18px;
    color: #fff;
    font-weight: normal;
    font-style: normal;
    background: transparent;
  }
  .el-pagination .btn-prev .el-icon,
  .el-pagination .btn-next .el-icon {
    font-size: 18px;
  }
  .el-pagination button:hover,
  .el-pager li.active,
  .el-pager li:hover {
    color: #0035fb;
  }

  &.dark {
    .page-info-tip {
      color: #333;
    }
    .el-pagination .btn-prev,
    .el-pagination .btn-next {
      color: #333;
    }
    .el-pagination button:disabled {
      opacity: 0.8;
      &:hover {
        color: #333;
      }
    }
    .el-pagination button:hover,
    .el-pager li.active,
    .el-pager li:hover {
      color: #0035fb;
    }
  }
}
</style>
